import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { FirstTour } from "@/components/FirstTour";
import { PhonePrompt } from "@/components/PhonePrompt";
import { DayHeader, TodoCard, DealsCard, NumbersCard } from "@/components/DayBoard";
import { NextEventCard } from "@/components/NextEventCard";
import { useAuth } from "@/context/AuthContext";

export { remindAction } from "@/components/RemindPreview";

export default function MeuDia() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  const { user } = useAuth();
  useEffect(() => { api.get("/me/day").then(({ data }) => setD(data)).catch((e) => { setErr(true); toast.error(apiErr(e.response?.data?.detail)); }); }, []);
  if (err) return <div className="text-slate-500 py-20 text-center" data-testid="my-day-error">Não foi possível carregar. Tente novamente.</div>;
  if (!d) return <div className="text-slate-400 py-20 text-center">A carregar…</div>;
  return (
    <div className="max-w-[1280px] mx-auto space-y-4 -mt-2" data-testid="my-day-page">
      <FirstTour uid={user?.id} />
      <PhonePrompt />
      <DayHeader d={d} />
      <div className="space-y-5 lg:space-y-0 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-6 lg:items-start" data-testid="my-day-columns">
        <TodoCard b={d.board} />
        <div className="space-y-4">
          <NextEventCard e={d.next_event} />
          <DealsCard b={d.board} total={d.deals_total} />
          <NumbersCard d={d} />
        </div>
      </div>
    </div>
  );
}
